export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.gedditlocal.mobile'
export const APP_STORE_URL = 'https://apps.apple.com/us/app/ssu/id1560583285'
